import React from 'react';
import './PageNotFound.scss';

const UnVerifiedUser = () => {
  return (
    <div className="pageNotFound-Unverified">
      <div className="fof">
        <h1>Kindly contact your admin (via slack) to approve your account.</h1>
      </div>
    </div>
  );
};

export default UnVerifiedUser;
